import classNames from "classnames"
import React from "react"

type PayflexLogoProps = {
  size?: "small" | "large"
  variant?: "default" | "light"
  iconOnly?: boolean
}

export const PayflexLogo = ({
  size = "small",
  variant = "default",
  iconOnly = false,
}: PayflexLogoProps) => (
  <div
    className={classNames(
      "flex items-center justify-center",
      {
        "bg-payflex-purple": variant === "default",
      },
      {
        [`h-[30px] rounded-8 px-[8px] py-[7px] sm:h-[35px] sm:px-[9px] sm:py-[8px] ${iconOnly ? "max-h-[30px] min-w-[30px]" : "w-[90px] sm:w-[105px]"}`]:
          size === "small",
      },
      {
        [`h-[50px] rounded-[71px] px-[15px] py-[12px] sm:h-[71px] sm:rounded-[100px] sm:px-[22px] sm:py-[18px] ${iconOnly ? "!h-[50px] !w-[50px]" : "w-[148px] sm:w-[207px]"}`]:
          size === "large",
      }
    )}
  >
    {variant === "light" ? (
      <img
        className="h-full w-auto"
        src={
          iconOnly
            ? "/icons/payflex-icon-light.svg"
            : "/icons/payflex-logo-light.svg"
        }
        alt="Payflex Logo"
      />
    ) : (
      <img
        className="h-full w-auto"
        src={iconOnly ? "/icons/payflex-icon.svg" : "/icons/payflex-logo.svg"}
        alt="Payflex Logo"
      />
    )}
  </div>
)
